import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Button, Text, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';
import InputSearch from '../../../shared/inputSearch/InputSearch';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import TalentsTable from './TalentsTable';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';
import { getTalents, approveTalent, disapproveTalent } from '../../../../store/talents/talentsSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const LABELS = {
  programmer: { page: 'المبرمجين', empty: 'لا يوجد طلبات مبرمجين' },
  designer: { page: 'المصممين', empty: 'لا يوجد طلبات مصممين' },
  beta_tester: { page: 'لاعبين بيتا', empty: 'لا يوجد طلبات لاعبين بيتا' },
};

const Talents = ({ category }) => {
  const dispatch = useDispatch();
  const talents = useSelector(state => state.talents);
  const labels = LABELS[category];

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');

  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    dispatch(getTalents({ page, query, filter: JSON.stringify({ category }) }));
  }, [dispatch, page, query, category]);

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage={labels.page} pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />

      {talents.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {talents.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8} />
        <Flex marginBottom={8} justifyContent="flex-end">
          <InputSearch isLoading={talents.isLoading} handleSearch={(q) => setQuery(q)} />
        </Flex>
      </SimpleGrid>

      {talents.data?.itemsCount > 0 ? (
        <TalentsTable
          data={talents.data.data}
          page={page}
          handleUpdate={(el) => setShowUpdate(el)}
          handleDelete={(el) => setShowDelete(el)}
          handleApprove={(el) => dispatch(approveTalent({ _id: el._id }))}
          handleDisapprove={(el) => dispatch(disapproveTalent({ _id: el._id }))}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {labels.empty}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={talents.data?.itemsCount ?? 0}
          onChange={(p) => setPage(p)}
        />
      </Flex>

      {showUpdate && <UpdateModal category={category} data={showUpdate} onClose={() => setShowUpdate(false)} />}
      {showDelete && <DeleteModal data={showDelete} onClose={() => setShowDelete(false)} />}
    </RulesWrapper>
  );
};

export default Talents;
